// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"158":"labels","549":"locations","594":"about"}[chunkId] || chunkId) + "." + {"158":"d1ec70bf","171":"ea5b4b61","549":"05ed5e37","594":"b787eaba"}[chunkId] + ".css";
};